import LatestTransactions from 'components/common/LatestTransactions/LatestTransactions';

export const Transactions = () => {
  return (
    <section className={'page-container'}>
      <LatestTransactions />
    </section>
  );
};
